<template>
    <div class="listview">
        <div v-if="this.$parent.$route.params.subid">
            {{this.$parent.setBacklink('/top/' + this.$parent.$route.params.topid)}}
        </div>
        <div v-else>
            {{this.$parent.setBacklink('/top')}}
        </div>
        <div v-if="this.$parent.logintoken && !triggeredPostlist">{{ getPostList() }}</div>
        <div v-if="!this.$ms.hasElements(postlist)">
            <div v-if="nodata">
                Keine Beiträge gefunden.
            </div>
            <div v-else>
                Lade Beiträge...
                <font-awesome-icon icon="spinner" spin/>
            </div>
        </div>
        <div v-if="this.$ms.hasElements(postlist)">
            <div v-for="post in postlist" :key="post.id" class='postitem-base'>
                <div :class="'postitem-' + post.id + ' postitem' + (post.sticky == '1' ? ' sticky' : '')">                                        
                    <h4>{{post.title}}</h4>
                    <h3 v-if="post.content && post.content.length"><router-link :to="route(post.id)">{{post.meta_titel2}}</router-link></h3>
                    <h3 v-else>{{post.meta_titel2}}</h3>
                    <div v-if="post.meta_ausgabe && post.meta_ausgabejahr" class="ausgabe">
                        Ausgabe {{ post.meta_ausgabe }} / {{ post.meta_ausgabejahr }}<span v-if="post.meta_erscheinungsdatum">,&nbsp;{{formatDate(post.meta_erscheinungsdatum)}}</span>
                    </div>
                    <div v-if="post['pic_attachment_id'] && post['attachments']">
                        <div v-for="attachment in post['attachments']" :key="attachment.id">                            
                            <div v-if="(attachment.id == post['pic_attachment_id']) && (attachment['mime_type'].substr(0,6) == 'image/') && attachment.url">
                                <router-link v-if="post.content && post.content.length" :to="route(post.id)"><img class="img-teaser" v-bind:src="attachment.url" /></router-link>
                                <img v-else class="img-teaser" v-bind:src="attachment.url" />
                            </div>
                        </div>
                    </div>

                    <p v-html="post.excerpt"></p>
                    <p v-if="post.content && post.content.length > 0">
                        <router-link :to="route(post.id)">{{post.hasaccess ? 'Artikel lesen' : 'Artikel-Vorschau'}}</router-link>
                    </p>                    
                </div>
            </div>
        </div>
        <div v-if="false && !infiniteAjaxResponse" v-infinite-scroll="loadMore" infinite-scroll-disabled="infiniteDone" infinite-scroll-distance="50">
            Lade weitere Beiträge...
            <font-awesome-icon icon="spinner" spin/>
        </div>            
    </div>
</template>
<script>

import MS_CONST from '../msclasses/msconst.js'

export default {
    name: "Listview",
    props: {
    },
    data() {
        return {
            listitem: String,
            postlist: {},
            nodata: false,
            infiniteDone: true,
            infiniteAjaxResponse: false,
            triggeredPostlist: false,
            jumpid: false
        };
    },
    created() {
        if (this.$parent.$route.params.subid){
            this.$parent.setBacklink('/top/' + this.$parent.$route.params.topid);
            this.listitem = this.$parent.$route.params.subid;
            this.$log.debug('Listitem: ', this.listitem);
        }
        else {
            this.$parent.setBacklink('/top');
        }        
        this.buildSubTopiclist();
    },
    mounted() {
        require('../assets/css/Listview.css')
        try { require('../assets/css/' + this.$mode + '/Listview.css') } catch (e) {}
    },
    updated() {
        if (this.jumpid) {
            this.jumpto(this.jumpid);
            this.jumpid = false;
        }
    },
    methods: {
        getPostList: function() {            
            // Cache-Strategie: "Wenn online, Netzwerk, sonst Cache"
            // Ist der User online, wird die Netzwerk-Version geladen und angezeigt.
            // Die geladene Version wird in den Cache gespeichert.
            // Ist der User offline, wird falls vorhanden die Cache-Version angezeigt
            var self = this;
            self.$log.debug('getPostList Start');
            self.triggeredPostlist = true;
            self.nodata = false;
            var topid  = (typeof self.$parent.$route.params.topid != 'undefined') ? self.$parent.$route.params.topid : -1;
            var subid  = (typeof self.$parent.$route.params.subid != 'undefined') ? self.$parent.$route.params.subid : false;
            var jumpid = (typeof self.$parent.$route.params.jumpid != 'undefined') ? self.$parent.$route.params.jumpid : false;
                
            if (self.$ms.isOnline()) {                    
                self.$ms.apiPostlist(self, self.$parent.logintoken, topid, subid, function(err, data) {
                    if (!err)
                        {                            
                        self.$log.debug('postlist read from web');    
                        if (self.$ms.hasElements(data)) {
                            self.postlist = data;
                            self.infiniteDone = false;
                            if (jumpid)
                                self.jumpid = jumpid;
                        }
                        else
                            self.nodata = true;
                        // In den Cache speichern
                        self.$log.debug('postlist from web saved to cache');    
                        self.$ms.saveCacheContentList(topid, subid, data);

                        // Weiterleitung prüfen
                        self.checkForward();
                        }
                    else {
                        self.$log.warn('msAxios meldet: ' + error);
                        self.$ms.showError(self, 'Die gewünschte Ressource konnte nicht geladen werden.');
                        self.nodata = true;
                    }
                });
            }
            else {
                this.$ms.loadCacheContentList(topid, subid, function(cache) {
                    var cacheFound = (cache && self.$ms.hasElements(cache));
                    if (cacheFound) {
                        self.$log.debug('postlist read from cache');
                        self.postlist = cache;
                        self.infiniteDone = false;
                            if (jumpid)
                                self.jumpid = jumpid;
                    } 
                    if (!cacheFound && !self.$ms.isOnline()) {
                        self.$ms.showError(self, 'Die gewünschte Ressource konnte nicht geladen werden. Bitte verbinden Sie sich mit dem Internet und versuchen es erneut.');
                        self.nodata = true;
                    }
                    self.checkForward();
                });        
            }
        },
        buildSubTopiclist() {
            var self = this;
            var topid = (typeof self.$parent.$route.params.topid != 'undefined') ? self.$parent.$route.params.topid : -1;
            this.$ms.loadCacheLogin(function(login) {
                if (login && login.topiclist) {                        
                    self.$log.debug('Build subtopic items. Topid:', topid);
                    self.$parent.subtopics = [];
                    login.topiclist.forEach(function(item) {
                        if (topid == item.list_id) {
                            item.subtopiclist.forEach(function(subitem) {
                                self.$parent.subtopics.push({ label: subitem.list_label, id: subitem.list_id, top: item.list_id });
                                self.$parent.topicheaders[subitem.list_id] = subitem.list_label;                                
                            });
                        }
                        self.$parent.topicheaders[item.list_id] = item.list_label;
                    });
                }
                else    
                    self.$log.debug('Keine Topicliste');
            });
        },
        loadMore: function() {
            var self = this;
            this.infiniteDone = true;
            this.$log.warn('Load More: infiniteDone!');
            // Die Anzahl angezeigter Beiträge soll aus MS_CONST.MAX_POSTS kommen.
            setTimeout(function() { 
                // todo: Nur Proof of Concept. Nach 3 Sekunden wird der "Lade"-Schriftzug ausgeblendet, als ob nichts gefunden worden wäre
                self.infiniteAjaxResponse = true;
            }, 3 * 1000);
        },                
        route(id) {
            var topid = (typeof this.$parent.$route.params.topid != 'undefined') ? this.$parent.$route.params.topid : -1;
            if (this.$parent.$route.params.subid)
                return "/top/" + topid + "/sub/" + this.$parent.$route.params.subid + "/post/" + id;
            else
                return "/top/" + topid + "/post/" + id;
        },
        checkForward() {
            // Wenn einer Top-Katekorie nur EIN Beitrag zugeordnet ist, zeige ihn direkt an!
            if (!this.$parent.$route.params.subid && this.$ms.countElements(this.postlist) == 1) {                
                let post = this.postlist[Object.keys(this.postlist)[0]];
                let route = '/top/' + this.$parent.$route.params.topid + '/post/' + post.id + '/fw/';
                this.$log.info('Forward to detail page: ' + route);
                this.$router.push(route);
            }
        },
        jumpto(jumpid) {
            var self = this;
            self.$log.debug('Jump to jumpid ', jumpid);
            var el = self.$el.getElementsByClassName("postitem-" + jumpid)[0];
            el.scrollIntoView();
        },
        formatDate(date) {
            // Eingabeformat: yyyymmdd, Ausgabeformat: dd.mm.yyyy
            let d = date.substr(6,2);
            let m = date.substr(4,2);
            let y = date.substr(0,4);
            return d + "." + m + "." + y;
        }
    }
};
</script>
<style />